import Github from 'images/github.svg'
import linkImage from 'images/Link.svg'

import Tag from './Tag'

type Props = {
  project: {
    name: string
    id?: string | null
    link?: string
    github?: string
    description?: string
    tags?: string[]
    challenges?: string[]
    lessons?: string[]
  }
}

export default function ProjectItem({ project }: Props) {
  const { name, description, tags, link, github } = project
  return (
    <li className='lg:px-6 py-8 lg:hover:bg-neutral-200/60 lg:dark:hover:bg-neutral-700 rounded-md transition duration-300 ease-in-out'>
      <div>
        <div className='flex items-baseline mb-3'>
          <h3 className=' font-semibold text-xl mr-3'>{name}</h3>
          {link && (
            <a href={link} className='flex items-center mr-2 transition delay-100 duration-300 ease-in-out hover:-translate-y-1 cursor-pointer' target='_blank' rel='noreferrer'>
              <img src={linkImage} alt={name} className='w-4 h-4' />
            </a>
          )}
          {github && (
            <a href={github} className='transition delay-100 duration-300 ease-in-out hover:-translate-y-1 cursor-pointer' target='_blank' rel='noreferrer'>
              <img src={Github} alt='github' className='w-4 h-4' />
            </a>
          )}
        </div>
        <p>{description}</p>
        {tags?.length && (
          <ul className='flex flex-wrap'>
            {tags.map((tag) => (
              <Tag key={tag} tag={tag} />
            ))}
          </ul>
        )}
      </div>
    </li>
  )
}
